import {
    Avatar, ButtonBase,
    Dialog, Grid, IconButton, ListItem, Typography, withStyles
} from '@material-ui/core';
import ListView from 'antd-mobile/lib/list-view/index';
import React from 'react';
import Carousel, { Modal, ModalGateway } from 'react-images';
import { withRouter } from 'react-router-dom';
import AppUtils from '../../control/apputlis';
import ChatUtils from '../../control/ChatUtils';
import DateUtils from '../../control/dateutils';
import FIMUtils from "../../im/FIMUtils";
import AppData from '../../model/AppData';
import IMApp from '../../net/IMApp';
import IMEventEmitter, { IMEvent } from '../../net/IMEventEmitter';
import MessageType from '../../net/IMMessageType';
import StringUtils from '../../net/IMStringUtils';
import MBack from '../view/MBack';
import MChatModal from '../view/MChatModal';
import MSnackbar from '../view/MSnackbar';
import './redPackets.css';




const ICON_FACE = require("../../images/icons/biaoqing.png");

const ICON_REDP = require("../../images/icons/hongbao_icon.png");
const ICON_offDialog = require("../../images/icons/redoff.png");
const ICON_openR = require("../../images/icons/kai_icon.png");

//聊天详情
class PrivateLetter extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            message: '',
            messageList: [],
            isCompleted: false,
            nextReqMessageID: '',
            open: false,
            isRefreshing: false,
            isShowDialog: false,
            redName: '',
            redAvatar: '',
            redBagId: null,
            redBagType: 1,
            isReset: true,
            modalIsOpen: false,
            imgUrl: []
        };

        this.ds = new ListView.DataSource({
            rowHasChanged: (r1, r2) => r1 !== r2
        });


    }

    componentDidMount() {
        AppUtils.YMPush('MAIN', 'PrivateLetter');
        const { nextReqMessageID } = this.state;
        this.loadHistory(nextReqMessageID);
        IMEventEmitter.on(IMEvent.EVENT_MESSAGE_RECEIVED, this.onMessageReceived, this);
        //打开红包监听
        IMEventEmitter.on('S2C_MSG_GET_REDBAG_REP', this.onRedBagMessage, this);
        //监听是否发送消息失败
        IMEventEmitter.on('S2C_MSG_SEND_PRIVATE_MSG_REP_ERR', this.onSendMsgErr, this);

        //检查红包状态
        // IMEventEmitter.on('S2C_MSG_GET_REDBAG_INFO_REP', this.onRedBagInfo, this);

        this.setMessageRead();
        const ua = window.navigator.userAgent.toLocaleLowerCase();
        const isIOS = /iphone|ipad|ipod/.test(ua);

        if (isIOS) {
            document.body.addEventListener('focusin', this.focusinHandler);
            document.body.addEventListener('focusout', this.focusoutHandler);
        }
    }
    focusinHandler = () => {
        this.state.isReset = false; //聚焦时键盘弹出，焦点在输入框之间切换时，会先触发上一个输入框的失焦事件，再触发下一个输入框的聚焦事件
    };

    focusoutHandler = () => {
        this.state.isReset = true;
        this.timeOut = setTimeout(() => {
            //当焦点在弹出层的输入框之间切换时先不归位 
            if (this.state.isReset) {
                window.scroll(0, 10000);
                if (this.listView) {
                    this.listView.scrollTo(0, 10000);
                }
                this.setState()
            }
        }, 30);
    };

    componentWillUnmount() {
        IMEventEmitter.off(IMEvent.EVENT_MESSAGE_RECEIVED, this.onMessageReceived, this);
        IMEventEmitter.off('S2C_MSG_SEND_PRIVATE_MSG_REP_ERR', this.onSendMsgErr, this);
        IMEventEmitter.off('S2C_MSG_GET_REDBAG_REP', this.onRedBagMessage, this);
        if (this.timeOut) {
            clearTimeout(this.timeOut)
        }
        this.setState = () => false;
    }

    onSendMsgErr = (e) => {
        console.log('发送失败', e);
        //发送失败
        if (e == 0) {
            this.toast.show('发送失败');

        } else if (e == 6) {
            this.toast.show('发送失败，不是好友');

        }
        let { messageList } = this.state;
        messageList.pop()
        this.setState({ messageList });
    }

    setMessageRead = () => {
        let { user_id } = this.props.match.params;
        FIMUtils.setMessageRead(user_id)
    }

    isMessageExist = (message) => {
        const { messageList } = this.state;
        for (let i = messageList.length - 1; i >= 0; i--) {
            if (messageList[i].chatmsgno == message.chatmsgno) {
                return true;
            }
        }
        return false;
    }

    onMessageReceived = (event) => {
        console.log('有消息进来了====>', event);
        const { messageList } = this.state;
        let { user_id } = this.props.match.params;

        let msgNoList = [];
        for (let i = 0; i < event.length; i++) {
            /**不是一个会话的消息 */
            if (event[i].chatkey != user_id) {
                continue;
            }

            if (event[i].msgtype == MessageType.RECALL) {
                let msgrecall = event[i];
                let msgcontent = JSON.parse(msgrecall.content);
                for (let j = 0; j < messageList.length; j++) {
                    if (messageList[j].chatmsgno == msgcontent.chatmsgno) {
                        messageList.splice(j, 1)
                    }
                }
            }

            msgNoList.push(event[i].chatmsgno);
            if (!this.isMessageExist(event[i])) {
                if (this.validMessage(event[i])) {
                    messageList.push(event[i]);
                }
            }
        }

        FIMUtils.setMessageHasRead(user_id, msgNoList);

        this.setState({ messageList: messageList }, () => {
            if (this.listView) {
                this.listView.scrollTo(0, 10000);
            }
        });
    }

    validMessage = (message) => {
        let msgtype = message.msgtype;
        if (FIMUtils.isMessageText(msgtype) || FIMUtils.isMessageImage(msgtype) || FIMUtils.isRedBag(msgtype)) {
            return true;
        }
        return false;
    }

    loadHistory = async (nextReqMessageID) => {
        let { user_id } = this.props.match.params;
        let conversationMessageList = FIMUtils.getConversationMessageList(user_id);
        let msgList = [];
        let msgNoList = [];
        if (conversationMessageList && conversationMessageList.length > 0) {
            for (let i = 0; i < conversationMessageList.length; i++) {
                if (this.validMessage(conversationMessageList[i])) {
                    msgList.push(conversationMessageList[i]);
                    msgNoList.push(conversationMessageList[i].chatmsgno);
                }
            }

            FIMUtils.setMessageHasRead(user_id, msgNoList);

            this.setState({ messageList: msgList }, () => {
                if (this.listView) {
                    this.listView.scrollTo(0, 10000);
                }
            });
        }
    }


    //发消息
    _sendC2CMessage = (message) => {
        if (message === '') {
            this.toast.show('请输入内容.');
            return;
        }
        let { user_id } = this.props.match.params;
        if (!user_id) return;
        let result = FIMUtils.sendTextMessage(user_id, message, false)
        console.log(result);
        let { messageList } = this.state;
        if (messageList.length > 0) {
            messageList.push(result);
            // messageList = messageList.sort((a, b) => {
            //     return a.chatmsgno - b.chatmsgno;
            // });
        }




        this.setState({ messageList: messageList, message: '' }, () => {
            if (this.listView) {
                this.listView.scrollTo(0, this.listView.listviewRef.scrollProperties.contentLength);
            }
        });
    }



    _sendGroupMessage = (message) => {
        if (message === '') {
            this.toast.show('请输入反馈内容.');
            return;
        }

        let { user_id } = this.props.match.params;
        if (!user_id) return;

        let result = FIMUtils.sendTextMessage(user_id, message, true);
        let { messageList } = this.state;
        messageList.push(result);
        messageList = messageList.sort((a, b) => {
            return a.chatmsgno - b.chatmsgno;
        });
        this.setState({ messageList: messageList, message: '' }, () => {
            if (this.listView) {
                this.listView.scrollTo(0, this.listView.listviewRef.scrollProperties.contentLength);
            }
        });
    }

    sendMessage = (message) => {
        let { type } = this.props.match.params;
        if (type == 'userProfile') {
            this._sendC2CMessage(message);
        } else if (type == 'groupProfile') {
            this._sendGroupMessage(message);
        }

        let { user_id } = this.props.match.params;
        if (user_id) {
            let conversation = IMApp.getConversation(user_id); 
            if (conversation && conversation.isAd) {
                AppUtils.YMPush('MAIN', '回复群发');
            }
        }
    }

    _onSendTextMsg = () => {
        const { message } = this.state;
        this.sendMessage(message);
    }

    _onSendAllMsg = (dom) => {
        let message = '';
        for (let i = 0; i < dom.childNodes.length; i++) {
            let child = dom.childNodes[i];
            if (child.nodeName == 'IMG') {
                message += child.alt;
            } else if (child.nodeName == '#text') {
                message += child.nodeValue;
            }
        }
        this.sendMessage(message);
        this.setState({ open: false });
    }


    isNumber(val) {
        var regPos = /^\d+(\.\d+)?$/; //非负浮点数
        var regNeg = /^(-(([0-9]+\.[0-9]*[1-9][0-9]*)|([0-9]*[1-9][0-9]*\.[0-9]+)|([0-9]*[1-9][0-9]*)))$/; //负浮点数
        if (regPos.test(val) && regNeg.test(val)) {
            return true;
        } else {
            return false;
        }
    }

    _handleImageMessage = (images) => {
        let { user_id, type } = this.props.match.params;
        if (!user_id) return;
        if (!images || !images.files || images.files.length == 0) {
            return;
        }
        let isGroup = type == 'groupProfile';
        this.setState({ open: false });
        console.log('_handleImageMessage==>', images);
        FIMUtils.sendImageMessage(user_id, images.files[0], isGroup).then(result => {
            let { messageList } = this.state;
            messageList.push(result);
            messageList = messageList.sort((a, b) => {
                return a.chatmsgno - b.chatmsgno;
            });
            this.setState({ messageList: messageList, message: '' }, () => {
                if (this.listView) {
                    this.listView.scrollTo(0, 0);
                }
            });
        }).catch(err => {
            console.log('==========>', err);
        });
    }

    _handleChange = (message) => {
        this.setState({ message: message });
    }

    _showChatPanel = () => {
        this.setState({ open: true });
    }

    _handleClose = () => {
        console.log('_handleClose');
        this.setState({ open: false });
    }

    getImageInfo(msg) {
        try {
            let info = JSON.parse(msg.content);
            return FIMUtils.getFixImageSize(info);
        } catch (error) {
            return { url: '', width: 0, height: 0 }
        }
    }






    //监听打开红包
    onRedBagMessage = (e) => {
        const { redbag_id, result } = e

        if (this.state.redBagId == redbag_id) {
            if (result == 1) {
                let { user_id } = this.props.match.params;
                FIMUtils.setRedBagItem(user_id, redbag_id, 5);
                this.toRedBagOk(redbag_id)
            } else {
                this.setState({
                    redBagType: result
                })
                let { user_id } = this.props.match.params;
                FIMUtils.setRedBagItem(user_id, redbag_id, result);
            }
        }
    }

    //可以进入红包详情页了
    toRedBagOk = (id) => {
        this.closeDialog()
        this.props.history.push({ pathname: '/redBag/' + id, data: this.state.redBagContent });
    }

    toRedBag(id) {


        //打开红包
        FIMUtils.openRedBag(id)
        // this.closeDialog()
        // this.props.history.push({ pathname: '/redBag/' + id});
    }

    openDialog(msg, redcontent, type) {

        if (!AppData.me.isLogin()) {
            this.props.history.push('/login');
            return;
        }

        let { nickname, headurl, content } = msg;
        if (nickname.length > 13) {
            nickname = nickname.substring(0, 13) + '...'

        }
        let obj = JSON.parse(content)
        const id = obj.redbag_id

        // redBagType

        //打开红包
        this.setState({
            redBagType: type,
            isShowDialog: true,
            redName: nickname,
            redAvatar: headurl,
            redBagId: id,
            redBagContent: redcontent
        })
    }

    closeDialog() {
        //关闭红包
        this.setState({
            isShowDialog: false
        })
    }
    onClickImage = (image) => {
        console.log(image);
        let imglist = [{ source: image }]
        this.setState(state => ({ imgUrl: imglist }))
        this.toggleModal()
    }

    toggleModal = () => {
        this.setState(state => ({ modalIsOpen: !state.modalIsOpen }))
    }

    onItemClick = (data) => {
        console.log(data)
        if (!data || !data.content) {
            return
        }
        let urls = AppUtils.getUrlFromContent(data.content);
        if (urls && urls.length > 0) {
            AppUtils.openUrl(urls[0])
        }
    }

    _renderRight(i, avatar, msg) {
        const { classes } = this.props;
        let obj = this.getImageInfo(msg);
        let { content } = msg



        let type = 1

        if (FIMUtils.isRedBag(msg.msgtype)) {
            content = JSON.parse(content)
            type = content.type ? content.type : 1
            content = content.redbagname

        }


        let bgc = '#FD9322'
        if (type == 5 || type == 4) {
            bgc = '#FFD19F'
        }
        if (type == 8) {
            bgc = '#E5CAAC'
        }
        //如果是红包
        if (msg.msgtype == 16) {
            content = JSON.parse(msg.content)
        }

        return (
            <ListItem key={'right_' + i} style={{ alignItems: 'flex-start', paddingLeft: 8, paddingRight: 8 }} >
                <Avatar className={classes.avatar} src={avatar} />
                {/* //如果是文字 */}
                {
                    FIMUtils.isMessageText(msg.msgtype) && <div className='rendNickname'>
                        {msg.isGroup && <div className='itemNickname'> {msg.nickname}</div>}
                        <div className={classes.rightp2} style={{ marginRight: 30 }} >
                            {
                                ChatUtils.createHtml(msg.content)
                            }
                        </div>
                    </div>
                }
                {/* {
                    FIMUtils.isMessageText(msg.msgtype) &&  <div className={classes.rightp}>
                        {
                            ChatUtils.createHtml(msg.content)
                        }
                    </div>
                } */}
                {/* //如果是红包 */}
                {
                    FIMUtils.isRedBag(msg.msgtype) &&

                    <div className={classes.redPacketsBox} style={{ backgroundColor: bgc, }} onClick={() => this.openDialog(msg, content, type)}>
                        <div className='topBox'>
                            <img src={ICON_REDP} ></img>
                            <div >
                                <Typography className='text'>{content}</Typography>
                                {type == 5 &&
                                    <div className='tip'>已经领取过该红包</div>
                                }
                                {type == 4 &&
                                    <div className='tip'>手慢了，红包派完了</div>
                                }
                            </div>
                        </div>
                        <div className='bottomBox' style={{ borderTop: type == 1 ? '1px solid #FFAC53' : '0', color: type == 1 ? '#FED3A4' : '#fff' }}>
                            积分红包
                        </div>
                    </div>


                }
                {/* 如果是图片 */}
                {
                    FIMUtils.isMessageImage(msg.msgtype) && <Grid style={{ marginLeft: 8, marginRight: 8 }}>
                        <img alt='' onClick={() => this.onClickImage(obj.url)} src={obj.url} height={obj.height} width={obj.width} style={{ width: obj.height, height: obj.width, objectFit: 'cover' }}></img>
                    </Grid>
                }

                {/* 如果是@所有人 */}
                {
                    msg.isGroup && msg.msgtype === 16 && <div className='rendNickname'>
                        {msg.isGroup && <div className='itemNickname'> {msg.nickname}</div>}
                        <div className={classes.rightp2} style={{ marginRight: 30 }}>
                            {
                                ChatUtils.createHtml(content.content)
                            }
                        </div>
                    </div>
                }
            </ListItem>
        );
    }

    _renderLeft(i, avatar, msg) {
        const { classes } = this.props;
        let obj = this.getImageInfo(msg);
        let { content } = msg



        let type = 1

        if (FIMUtils.isRedBag(msg.msgtype)) {
            content = JSON.parse(content)
            type = content.type ? content.type : 1
            content = content.redbagname

        }
        let bgc = '#FD9322'
        if (type == 5 || type == 4) {
            bgc = '#FFD19F'
        }
        if (type == 8) {
            bgc = '#E5CAAC'
        }
        return (
            <ListItem key={'left_' + i} style={{ alignItems: 'flex-start', justifyContent: 'flex-end', paddingLeft: 8, paddingRight: 8 }} >
                {
                    FIMUtils.isMessageText(msg.msgtype) && <div className={classes.leftp}  >
                        {
                            ChatUtils.createHtml(msg.content)
                        }
                    </div>
                }
                {/* //如果是红包 */}
                {
                    FIMUtils.isRedBag(msg.msgtype) &&


                    <div className={classes.redPacketsBox} style={{ backgroundColor: bgc, }} onClick={() => this.openDialog(msg, content, type)}>
                        <div className='topBox'>
                            <img src={ICON_REDP} ></img>
                            <div >
                                <Typography className='text'>{content}</Typography>
                                {type == 5 &&
                                    <div className='tip'>已经领取过该红包</div>
                                }
                                {type == 4 &&
                                    <div className='tip'>手慢了，红包派完了</div>
                                }
                            </div>
                        </div>
                        <div className='bottomBox'>
                            积分红包
                        </div>
                    </div>


                }
                {
                    FIMUtils.isMessageImage(msg.msgtype) && <Grid style={{ marginLeft: 8, marginRight: 8 }}>
                        <img alt='' onClick={() => this.onClickImage(obj.url)} src={obj.url} height={obj.height} width={obj.width} style={{ maxWidth: '100%', height: 'auto', objectFit: 'scale-down' }}></img>
                    </Grid>
                }
                <Avatar className={classes.avatar} src={avatar} />
            </ListItem>
        );
    }

    _renderTips(i, msg) {
        return (
            <ListItem
                key={'tips_' + i}
                style={{ alignItems: 'flex-start', justifyContent: 'center', paddingTop: 0, paddingBottom: 0, marginTop: 10, marginBottom: 10 }}>
                <Typography style={{ color: '#878787', fontSize: 11 }}>{msg}</Typography>
            </ListItem>
        );
    }



    _renderByType(item, i) {
        i = parseInt(i);
        const { messageList } = this.state
        if (item.isGroup && item.msgtype === 10000) {
            return this._renderTips(i, "\"" + item.content);
        }

        let showTime = true;
        if (i > 0) {
            let lastMsg = messageList[i - 1]
            if (item.msgtime - lastMsg.msgtime < 300) {
                showTime = false;
            }
        }

        let isMe = FIMUtils.isMe(item.uid);
        if (!isMe) {
            return (
                <Grid key={i} container direction='column' alignItems='center'>
                    {
                        showTime && this._renderTips(i, DateUtils.dateFormatMDHM(item.msgtime))
                    }
                    {
                        this._renderRight(i, item.headurl, item)
                    }
                </Grid>
            );
        } else {
            return (<Grid key={i} container direction='column' alignItems='center'>
                {
                    showTime && this._renderTips(i, DateUtils.dateFormatMDHM(item.msgtime))
                }
                {
                    this._renderLeft(i, item.headurl, item)
                }
            </Grid>);
        }
    }


    _onRefresh = () => {
        const { isCompleted, nextReqMessageID } = this.state;
        console.log('_onRefresh', isCompleted, nextReqMessageID);
        if (!isCompleted) {
            this.loadHistory(nextReqMessageID);
        }
    }

    _onEndReached = () => {

    }

    _renderFooter = () => {

    }

    _renderHeader = () => {
        return (<Grid style={{ height: 16 }}></Grid>)
    }

    _renderItem = (data, sectionID, rowID) => {
        if (data.msgtype == 12) {
            return <></>
        }
        return this._renderByType(data, rowID);
    }



    render() {
        const { messageList, message, open, modalIsOpen, imgUrl } = this.state;
        const { classes } = this.props;
        let nickname = this.props.location.data;

        let title = '通讯';
        if (!nickname || nickname.length == 0) {
            if (AppData.ServerConfig && AppData.ServerConfig.tap_show == 1) {
                title = '我的通讯';
            }
        } else {
            title = StringUtils.adapterString(nickname, 15);;
        }

        return (
            <MBack title={title} backgroundColor='#F7F7F7' >
                <ListView
                    initialListSize={messageList.length}
                    listPrefixCls='padding: 0px'
                    style={{ width: '100vw', minHeight: 'calc(100vh - 112px)', maxWidth: '100%', padding: 0, paddingTop: 8 }}
                    contentContainerStyle={{ width: '100%', padding: 0, height: '100%' }}
                    dataSource={this.ds.cloneWithRows(messageList)}
                    renderRow={this._renderItem}
                    pageSize={10}
                    useBodyScroll={false}
                    renderHeader={this._renderHeader}
                    onEndReached={this._onEndReached}
                    onEndReachedThreshold={10}
                    // pullToRefresh={
                    //     <PullToRefresh
                    //         refreshing={isRefreshing}
                    //         onRefresh={this._onRefresh}
                    //     />
                    // }
                    ref={el => this.listView = el}
                    renderFooter={this._renderFooter}
                >
                </ListView>
                <Grid container direction='row' alignItems='center' justifyContent='space-between' style={{ backgroundColor: '#FFF', height: 55, position: 'fixed', bottom: 0 }}>
                    <Grid container direction='row' alignItems='center' justifyContent='space-between' className={classes.inputBack}>
                        <input value={message} onChange={(e) => this._handleChange(e.target.value)} className={classes.input} placeholder='您如何看待这场球...'></input>
                        <IconButton onClick={() => this._showChatPanel()} className={classes.iconButton}>
                            <img src={ICON_FACE} style={{ width: 23, height: 23 }}></img>
                        </IconButton>
                    </Grid>
                    <Grid container direction='row' justifyContent='flex-end' style={{ maxWidth: 70 }}>
                        <ButtonBase onClick={() => this._onSendTextMsg()} className={classes.sendMsg}>发送</ButtonBase>
                    </Grid>
                </Grid>
                <MChatModal
                    open={open}
                    isFile={true}
                    onClose={() => this._handleClose()}
                    sendImageMessage={(images) => this._handleImageMessage(images)}
                    onSendMsg={(val) => this._onSendAllMsg(val)} />
                <MSnackbar ref={(ref) => { this.toast = ref }} />
                {/* 弹出红包 */}

                <Dialog open={this.state.isShowDialog} classes={{}}>
                    <div className='dialogBox'>
                        <div className='dialogR'>
                            <div className='rowBox'>
                                <div className='namebox'>
                                    <img src={this.state.redAvatar} />
                                    <div>{this.state.redName}发出的红包</div>
                                </div>
                                {this.state.redBagType == 1 && <Typography className='text'>恭喜发财，大吉大利</Typography>}
                                {this.state.redBagType == 5 && <Typography className='text'>已经领取过该红包</Typography>}
                                {this.state.redBagType == 4 && <Typography className='text'>手慢了，红包派完了</Typography>}
                                {this.state.redBagType == 8 && <Typography className='text'>红包已经过期</Typography>}

                            </div>
                            {
                                this.state.redBagType == 1 && <img src={ICON_openR} onClick={() => this.toRedBag(this.state.redBagId)}></img>
                            }
                            {this.state.redBagType != 1 &&
                                <div className='textDel' onClick={() => this.toRedBagOk(this.state.redBagId)}>
                                    查看领取详情 &gt;
                                </div>
                            }
                        </div>

                        {/* 关闭按钮 */}
                        <img src={ICON_offDialog} style={{ width: 35, height: 35 }} onClick={() => this.closeDialog()} />
                    </div>


                </Dialog>
                {/* 弹出图片 */}

                <ModalGateway>
                    {modalIsOpen ? (
                        <Modal onClose={() => this.toggleModal()}>
                            <Carousel views={imgUrl} />
                        </Modal>
                    ) : null}
                </ModalGateway>

            </MBack >
        );
    }
}
export default withRouter(withStyles((theme) => ({
    avatar: {
        width: 50,
        height: 50,
        color: '#fff',
        marginTop: 0,
        backgroundSize: 'cover',
        // backgroundImage: `url(${DefaultAvatarImg})`,
    },

    redPacketsBox: {
        margin: theme.spacing(0.2, 1, 0.2, 1),
        color: '#0D0D0D',
        borderRadius: 10,
        width: '60%',
        display: 'flex',
        flexDirection: 'column',
    },

    rightp: {
        color: '#0D0D0D',
        backgroundColor: '#fff',
        padding: theme.spacing(0.5, 1, 0.5, 1),
        borderRadius: 5,
        margin: theme.spacing(0.2, 1, 0.2, 1),
        fontSize: theme.typography.pxToRem(13),
        maxWidth: 'calc(100% - 132px)'
    },
    rightp2: {
        color: '#0D0D0D',
        backgroundColor: '#fff',
        padding: theme.spacing(0.5, 1, 0.5, 1),
        borderRadius: 5,
        margin: theme.spacing(0.2, 1, 0.2, 1),
        fontSize: theme.typography.pxToRem(13),

    },
    leftp: {
        color: '#FC3035',
        backgroundColor: '#FDEAEB',
        border: '0px solid #E2E2E2',
        padding: theme.spacing(0.5, 1, 0.5, 1),
        borderRadius: 5,
        margin: theme.spacing(0.2, 1, 1, 1),
        fontSize: theme.typography.pxToRem(13),
        maxWidth: 'calc(100% - 132px)'
    },
    payBtn: {
        background: '#F82A5C',
        borderRadius: 14.5,
        color: 'white',
        height: 29,
        width: 65,
        fontSize: theme.typography.pxToRem(13),
        position: 'absolute',
        right: 10,
        marginRight: 10,
        fontWeight: theme.typography.fontWeightBold,
    },
    textfield: {
        backgroundColor: '#F0F0F0',
        fontSize: 13,
        height: 35,
        marginLeft: 30,
        borderRadius: 5,
        width: '60%',
        justifyContent: 'flex-end',
        border: 'none',
        outline: 'none',
        padding: theme.spacing(0.2, 1, 0.2, 1),
    },
    inputBack: {
        backgroundColor: '#EDEDED',
        borderRadius: 17.5,
        height: 35,
        flex: 1,
        marginLeft: 8,
        marginRight: 8,
        display: 'flex',
    },
    input: {
        outline: 'none',
        border: 0,
        marginLeft: 16,
        backgroundColor: 'transparent',
        height: 35,
        flex: 1,
        fontSize: 12,
        display: 'flex',
        maxWidth: 'calc(100vw - 130px)'
    },
    sendMsg: {
        backgroundColor: '#007AFF',
        color: '#FFF',
        fontSize: 14,
        height: 35,
        width: 70,
        borderRadius: 17.5,
        marginRight: 8,
    },
    iconButton: {
        padding: theme.spacing(0, 0, 0, 0),
        margin: theme.spacing(0, 0, 0, 0),
        width: 20,
        height: 20,
        marginRight: 8
    },
}))(PrivateLetter));
